import type { Configuration } from '@azure/msal-browser'
import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '@utils/authConfig.ts'
import { getRuntimeConfig } from '@/config/runtime-config'

// Lazy initialization - instance is only created when first accessed
let _msalInstance: PublicClientApplication | null = null
let _msalInitPromise: Promise<void> | null = null

export const getMsalInstance = (): PublicClientApplication => {
  if (!_msalInstance) {
    // Ensure runtime config is loaded before creating MSAL
    const config = getRuntimeConfig()
    if (!config && import.meta.env.PROD) {
      throw new Error('Runtime configuration not loaded. MSAL cannot be initialized.')
    }

    _msalInstance = new PublicClientApplication(msalConfig as Configuration)
  }
  return _msalInstance
}

export const getMsalInitPromise = (): Promise<void> => {
  _msalInitPromise ??= getMsalInstance().initialize()
  return _msalInitPromise
}

// For backwards compatibility - but these will now be lazy
export const msalInstance = new Proxy({} as PublicClientApplication, {
  get(_, prop) {
    return getMsalInstance()[prop as keyof PublicClientApplication]
  },
})

// Export as a function to avoid eager evaluation
export const msalInitPromise = getMsalInitPromise
